export default "__VITE_ASSET__CKrWtpjJ__"